






















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class InsertionModal2 extends Vue {

    private isVisible : boolean = false;
    private callback : ((button : string) => void) | null = null;

    public open(callback : (button : string) => void)
    {
        this.callback = callback;
        this.isVisible = true;
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    private onClicked(button : string)
    {
        if(this.callback != null) this.callback(button);
        this.isVisible = false;
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
